const React = require('react');
import {SVGIcon} from '@homeaway/react-svg';
import {HEART_SELECTED__16} from '@homeaway/svg-defs/lib/defs/HEART_SELECTED__16';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {getTranslations} from '../../selectors';
import './empty-tripboard-label.less';

const EmptyTripboardLabel = ({large, translations}) => {
    const emptyText = translations['tripboards.main.empty.state'].split('{heart}'); // no message reader...
    const labelClassName = (large)
        ? 'h3 text-300'
        : 'text-muted';
    const iconClassName = (large)
        ? 'create-trip-board__cta_heart create-trip-board__cta_heart--large'
        : 'create-trip-board__cta_heart';
    return (
        <p className={labelClassName} data-wdio="tripboard-summary__empty-message">
            {emptyText[0]}
            <SVGIcon inlineFlex markup={HEART_SELECTED__16} className={iconClassName}/>
            {emptyText[1]}
        </p>
    );
};

EmptyTripboardLabel.propTypes = {
    large: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
    translations: getTranslations(state),
    ...ownProps
});

export default connect(mapStateToProps)(EmptyTripboardLabel);



// WEBPACK FOOTER //
// ./src/universal/tripboard/components/empty-tripboard-label.js